import React, { useState, useEffect } from "react";
import { useSpring, animated } from "react-spring";
import { makeStyles } from "@material-ui/core/styles";
import Button from "sushiweb/Button";
import Typography from "@mui/material/Typography";
import AutoComplete from "../Components/AutoComplete";
import "./dropdown.css";
import * as FeatureConfigActions from "../../../store/actions/FeatureConfig";
import * as UserActions from "../../../store/actions/User";
import ListView from "../ConfigList/ListView";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginTop: "25vh",
    height: "100vh",
  },
  dropdownContainer: {
    alignItems: "center",
    margin: theme.spacing(2, 0),
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
    minWidth: 200,
  },
}));

const HomeComponent = (props) => {
  const { getNamespaces, filterKeyConfigs } = props;
  const classes = useStyles();
  const history = useHistory();

  const [selectedNamespace, setSelectedNamespace] = useState("");
  const [selectedKey, setSelectedKey] = useState("");
  const [showListView, setShowListView] = useState(false);

  // Animation
  const fadeIn = useSpring({
    opacity: 1,
    from: { opacity: 0 },
  });

  const handleChange = (key, val) => {
    if (key === "key") {
      setSelectedKey(val);
    } else if (key === "namespace") {
      setSelectedNamespace(val);
      props.setCurrentNamespace(val);
    }
  };

  const handleShowConfig = () => {
    let queryString = `namespace=${selectedNamespace}`;
    queryString += `&key=${selectedKey}`;

    if (selectedKey == "") {
      queryString += "&entity=";
      queryString += "&entityId=";
    }

    const targetRoute = `/feature-config/list?${queryString}`;
    history.push(targetRoute);
  };

  const handleDisableClick = () => {
    props.setStatus({ type: "error", message: "Namespace is required" });
  };

  const headerStyle = {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px",
  };

  const handleClick = () => {
    history.push("/feature-config/namespaces");
  };

  const handleAccessControlClick = () => {
    history.push("/feature-config/access-control");
  }
  const handleBulkUpdateClick = () => {
    history.push("/feature-config/bulk-upload");
  }

  const handleBulkDeleteClick = () => {
    history.push("/feature-config/bulk-delete");
  }

  return (
    <>
      <div>
        <header style={headerStyle}>
          <Button btnColor="coal" size="small" onClick={handleClick}>
            Manage Namespaces
          </Button>
          <Button btnColor="coal" size="small" onClick={handleAccessControlClick} style={{marginLeft: "5px"}}>
            Access Control
          </Button>
          <Button btnColor="coal" size="small" onClick={handleBulkUpdateClick} style={{marginLeft: "5px"}}>
            Bulk Upload
          </Button>
          <Button btnColor="coal" size="small" onClick={handleBulkDeleteClick} style={{marginLeft: "5px"}}>
            Bulk Delete
          </Button>
        </header>
      </div>
      <animated.div style={fadeIn} className={classes.container}>
        {
          <div
            className={classes.dropdownContainer}
            style={{ minWidth: "25%" }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 400,
                textAlign: "center",
                marginBottom: "20px",
                color: "#1C1C1C",
                marginBottom: "40px",
              }}
            >
              Feature Config
            </Typography>
            <AutoComplete
              id="KeyListDropDown"
              className="sushi-dropdown"
              required
              getActiveList={getNamespaces}
              labelKey="namespace"
              defaultVal={{ selectedNamespace }}
              keyName="namespace"
              resKey="namespaces"
              label="Namespace"
              handleChange={handleChange}
              remoteSearchApplicable={true}
              keyTypeToSet="namespace"
              remoteSearchKey="namespace"
            />
            <AutoComplete
              id="KeyListDropDown"
              className="sushi-dropdown"
              getActiveList={props.getKeys}
              defaultVal={{ selectedKey }}
              resKey="keys"
              label="Key"
              activeListExtraParam={selectedNamespace}
              isStringList={true}
              keyName="key"
              keyTypeToSet="key"
              remoteSearchApplicable={true}
              handleChange={handleChange}
            />

            {selectedNamespace ? (
              <Button
                className="SubmitButton"
                variant="contained"
                style={{ backgroundColor: "black" }}
                onClick={handleShowConfig}
              >
                Search
              </Button>
            ) : (
              <>
                <Button
                  className="SubmitButton"
                  variant="contained"
                  style={{ backgroundColor: "black" }}
                  onClick={handleDisableClick}
                >
                  Search
                </Button>
              </>
            )}
          </div>
        }
      </animated.div>
    </>
  );
};

function mapStateToProps(state) {
  const { FeatureConfig } = state;
  return {
    namespaces: FeatureConfig.namespaces,
    keys: FeatureConfig.keys,
    prevPage: FeatureConfig.prevPage,
    nextPage: FeatureConfig.nextPage,
    currentNamespace: FeatureConfig.currentNamespace,
    currentKey: FeatureConfig.currentKey,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNamespaces: bindActionCreators(
      FeatureConfigActions.getNamespaces,
      dispatch
    ),
    getKeys: bindActionCreators(FeatureConfigActions.getKeys, dispatch),
    filterKeyConfigs: bindActionCreators(
      FeatureConfigActions.filterKeyConfigs,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    setCurrentNamespace: bindActionCreators(
      FeatureConfigActions.setCurrentNamespace,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeComponent);
